import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { checkUserAccess } from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import FilterComponent from "../../../components/comman/FilterComponent";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useDispatch, useSelector } from "react-redux";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import { updateFiltersStates } from "../../../store/actions/UserActions";
export default function TeamOd() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const [state, setState] = useState({
    userList: null,
    oDList: [],
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    currentPage: 1,
    pageSize: 10,
    count: 0,
    ...(checkUserAccess(userDetails).isUserAccess
      ? { staffType: "1" }
      : { staffType: "0" }),
    totalPages: 0,
    searchQuery: "",
    tableLoader: false,
    oDStatus: "",
    leaveType: "",
    sortByDate: [
      moment().subtract(1, "month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    siteList: [],
    siteId: filterDetails?.siteId,
    officeName: "",
    user: "",
    isInitial: true,
    isLoadingSite: false,
  });
  const timeoutId = useRef(null);

  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        activeTab: tab,
        currentPage: 1,
        siteId: "",
      }));
      // GetOfficeList();
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        activeTab: tab,
        currentPage: 1,
        siteId: filterDetails?.siteId,
      }));
      getSite();
    }
  };

  const GetOdRequest = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_od +
      MainFilterHandler({
        ...pageStates,
        orderBy: filterDetails?.orderBy,
        siteId: pageStates.activeTab == 1 ? "" : pageStates?.siteId,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.odRequest?.map((item) => ({
          ...item,
          empNameWithImage: item?.user?.name + "##" + item?.user?.profilePhoto,
          employeeDept: item?.user?.department?.name,
          officeName: item?.user?.site?.name,
          siteName: item?.user?.usersites?.[0]?.site?.name,
          appliedOn: moment(item?.createdAt).format("DD/MM/YYYY"),
          startDate: moment(item?.startDate).format("DD/MM/YYYY"),
          endDate: moment(item?.endDate).format("DD/MM/YYYY"),
          odStatus: item?.status,
        }));
        setState((pre) => ({
          ...pre,
          oDList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const getSite = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl?.get_user_site +
        `?pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.site?.id,
              label: item?.site?.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item.site?.id == filterDetails?.siteId
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  // const getSiteUser = (type, siteName) => {
  //   const option = {
  //     method: "GET",
  //   };
  //   const url =
  //     type === "office"
  //       ? apiUrl.get_office + `?officeId=${siteName}`
  //       : apiUrl.site_users + `?siteId=${siteName}`;
  //   callApi(url, option).then((res) => {
  //     if (res?.status === true) {
  //       setState((pre) => ({ ...pre, userList: res.data?.user || res?.data }));
  //       setPageStates((pre) => ({
  //         ...pre,
  //         ...(type === "office"
  //           ? { officeName: siteName }
  //           : { siteId: siteName }),
  //       }));
  //     } else {
  //       toast.error(res?.message);
  //     }
  //   });
  // };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeDept", label: "Emp. Dept." },
    { value: "siteName", label: "Site" },
    { value: "appliedOn", label: "Appllied Date" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
    { value: "odStatus", label: "Status" },
  ];

  const TableHeadingSite = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeDept", label: "Emp. Dept." },
    { value: "siteName", label: "Site" },
    { value: "appliedOn", label: "Appllied Date" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
    { value: "odStatus", label: "Status" },
  ];

  const TableHeadingOffice = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "employeeDept", label: "Emp. Dept." },
    { value: "officeName", label: "Office" },
    { value: "appliedOn", label: "Appllied Date" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
    { value: "odStatus", label: "Status" },
  ];

  useEffect(() => {
    GetOdRequest();
  }, [
    pageStates?.sortByDate,
    pageStates?.currentPage,
    pageStates.user,
    pageStates?.searchQuery,
    filterDetails.siteId,
    pageStates?.oDStatus,
    pageStates?.staffType,
    pageStates?.pageSize,
    filterDetails?.orderBy,
  ]);

  useEffect(() => {
    if (
      pageStates?.activeTab === 2 &&
      checkUserAccess(userDetails).isUserAccess
    ) {
      getSite();
    } else if (!checkUserAccess(userDetails).isUserAccess) {
      getSite();
    }
  }, []);

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const handleData = (data, type) => {
    // console.log(data);
    setPageStates((pre) => ({
      ...pre,
      ...(!type && { user: data?.user }),
      ...(!type && { oDStatus: data?.oDStatus }),
      ...(type == "site" && { siteId: data?.site }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type == "site" && { siteId: data?.site }),
      })
    );
    // if (type === "site" && data?.site) {
    //   getSiteUser("site", data?.site);
    // }
  };

  const handleView = (data) => {
    navigate(`${RoutesLink?.od_request_detail}/${data?.id}`, {
      state: { type: "teamRequest" },
    });
  };

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: handleView,
    },
  ];

  const sortListSite = {
    oDStatus: [
      { value: "", label: "Select Status" },
      { value: 1, label: "Approved" },
      { value: 0, label: "Pending" },
      { value: 2, label: "Rejected" },
    ],
    ...(pageStates.activeTab === 2 && { site: pageStates?.siteList }),
  };
  const sortListOffice = {
    oDStatus: [
      { value: "", label: "Select Status" },
      { value: 1, label: "Approved" },
      { value: 0, label: "Pending" },
      { value: 2, label: "Rejected" },
    ],
    site: pageStates?.siteList,
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Team O.D Request"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
        // buttonText={"Apply Leave"}
        // buttonIcon={<PlusIcon />}
        // buttonLink={RoutesLink?.add_customer}
        // clickHandler={toggleModal}
        />
        {checkUserAccess(userDetails).isUserAccess ? (
          <>
            <Nav tabs className="nav nav-tabs border-0 mb-4">
              <NavItem className="nav-item">
                <NavLink
                  className={
                    pageStates?.activeTab === 1
                      ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                      : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(1)}
                >
                  Office Staff O.D
                </NavLink>
              </NavItem>
              <NavItem className="nav-item ">
                <NavLink
                  className={
                    pageStates?.activeTab === 2
                      ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                      : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                  }
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleTab(2)}
                >
                  Site Staff O.D
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={pageStates?.activeTab}>
              <TabPane tabId={1}>
                <Fade in={pageStates?.activeTab === 1} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        handleSearch={handleSearchChange}
                        filterArray={sortListSite}
                        pageState={pageStates}
                        // leaveList={state?.siteList}
                        handleData={handleData}
                        sortHandler={handleData}
                        orderByHandler={orderByHandler}
                        orderByList={orderByList}
                        tableDataForExport={state?.oDList}
                        exportFileName={"Team_OD_Request_Data"}
                        exportColumns={[
                          "employeeName",
                          "employeeDept",
                          "officeName",
                          "appliedOn",
                          "startDate",
                          "endDate",
                          "odStatus",
                        ]}
                      />
                      <CommonTable
                        TableHeading={TableHeadingOffice}
                        TableData={state?.oDList}
                        currentPage={pageStates?.currentPage}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={pageStates?.totalPages}
                        count={pageStates?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={pageStates.pageSize}
                        ActionData={ActionData}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
              <TabPane tabId={2}>
                <Fade in={pageStates?.activeTab === 2} timeout={200}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <FilterComponent
                        // handleFilter={setPageStates}
                        handleSearch={handleSearchChange}
                        filterArray={sortListSite}
                        leaveList={state?.siteList}
                        pageStates={pageStates}
                        // dateChangeHandler={dateChangeHandler}
                        // handleFilterForAttendance={dateChangeHandler}
                        handleData={handleData}
                        sortHandler={handleData}
                        orderByHandler={orderByHandler}
                        orderByList={orderByList}
                        tableDataForExport={state?.oDList}
                        exportFileName={"Team_OD_Request_Data"}
                        getSite={getSite}
                        exportColumns={[
                          "employeeName",
                          "employeeDept",
                          "siteName",
                          "appliedOn",
                          "startDate",
                          "endDate",
                          "odStatus",
                        ]}
                      />
                      <CommonTable
                        TableHeading={TableHeadingSite}
                        TableData={state?.oDList}
                        ActionData={ActionData}
                        currentPage={pageStates?.currentPage}
                        PageChangeHandler={PageChangeHandler}
                        isLoading={pageStates?.tableLoader}
                        totalPages={pageStates?.totalPages}
                        count={pageStates?.count}
                        handleChangePageSize={handleChangePageSize}
                        pageSize={pageStates.pageSize}
                      />
                    </div>
                  </div>
                </Fade>
              </TabPane>
            </TabContent>
          </>
        ) : (
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                exportBtn={true}
                filterArray={sortListOffice}
                leaveList={state?.siteList}
                handleData={handleData}
                sortHandler={handleData}
                pageStates={pageStates}
                tableDataForExport={state?.oDList}
                exportFileName={"Team_OD_Request_Data"}
                exportColumns={[
                  "employeeName",
                  "employeeDept",
                  "siteName",
                  "appliedOn",
                  "startDate",
                  "endDate",
                  "odStatus",
                ]}
                getSite={getSite}
              />
              <CommonTable
                TableHeading={TableHeading}
                TableData={state?.oDList}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
